/* eslint-disable react/prop-types, no-unused-vars */

import RenameColumnForm from './transforms/RenameColumnForm';
import FilterRowsForm from './transforms/FilterRowsForm';
import CalculateFieldForm from './transforms/CalculateFieldForm';
import ReplaceValuesForm from './transforms/ReplaceValuesForm';
import RemoveDuplicatesForm from './transforms/RemoveDuplicatesForm';
import SplitColumnForm from './transforms/SplitColumnForm';
import MergeColumnsForm from './transforms/MergeColumnsForm';
import ConvertDataTypeForm from './transforms/ConvertDataTypeForm';
import TrimCleanTextForm from './transforms/TrimCleanTextForm';
import FillMissingValuesForm from './transforms/FillMissingValuesForm';
import SortDataForm from './transforms/SortDataForm';
import RemoveColumnForm from './transforms/RemoveColumnForm';
import PivotAggregateForm from './transforms/PivotAggregateForm';
import { TRANSFORM_TYPES } from './transformTypes';

const FORM_COMPONENTS = {
    RENAME_COLUMN: RenameColumnForm,
    FILTER_ROWS: FilterRowsForm,
    CALCULATE_FIELD: CalculateFieldForm,
    REPLACE_VALUES: ReplaceValuesForm,
    REMOVE_DUPLICATES: RemoveDuplicatesForm,
    SPLIT_COLUMN: SplitColumnForm,
    MERGE_COLUMNS: MergeColumnsForm,
    CONVERT_DATA_TYPE: ConvertDataTypeForm,
    TRIM_CLEAN_TEXT: TrimCleanTextForm,
    FILL_MISSING_VALUES: FillMissingValuesForm,
    SORT_DATA: SortDataForm,
    REMOVE_COLUMN: RemoveColumnForm,
    PIVOT_AGGREGATE: PivotAggregateForm,
};

const TransformConfigurator = ({ step, columns, onConfigChange }) => {
    const typeInfo = TRANSFORM_TYPES.find(t => t.type === step.type);
    const FormComponent = FORM_COMPONENTS[step.type];

    if (!FormComponent) {
        return <div>Unknown transform type: {step.type}</div>;
    }

    return (
        <div className="max-w-xl" data-testid="pipeline-configurator">
            <h3 className="mb-1 text-base font-semibold">
                Configure: {typeInfo ? typeInfo.label : step.type}
            </h3>
            <p className="mb-4 text-sm text-gray-500">
                Adjust the settings for this transformation step
            </p>

            <FormComponent
                key={step.order}
                config={step.config}
                columns={columns}
                onChange={onConfigChange}
            />

            <hr className="my-6 border-gray-200" />
            <div className="rounded border border-gray-200 bg-gray-100 px-4 py-3">
                <p className="mb-1 text-sm font-medium text-gray-900">Transformation Tips</p>
                <ul className="m-0 list-disc pl-4 text-sm leading-7 text-gray-900">
                    <li>Changes are previewed but not applied until you generate the view</li>
                    <li>You can disable/enable individual steps without removing them</li>
                    <li>The order of transformations matters - they execute sequentially</li>
                </ul>
            </div>
        </div>
    );
};

export default TransformConfigurator;
